<template>
    <div class="c-footer">
        <p>
            <small>
                Administratorem danych osobowych jest {{ $route.params.url != 'maxus' ? footerInfo['Krotoski'] : footerInfo['Maxus'] }}. Dane osobowe będą przetwarzane przez administratora danych osobowych w celach marketingowych oraz w celu przygotowania i przedstawienia oferty jazdy próbnej wybranym modelem pojazdu. Przysługuje Pani/Panu prawo dostępu do treści swoich danych oraz ich poprawiania. Podanie danych osobowych jest dobrowolne, jednak niezbędne do realizacji w/w celów przetwarzania danych osobowych
            </small>
        </p>
    </div>
</template>
<script>
export default {
  data() {
    return {
      footerInfo: {
        'Krotoski': 'Krotoski Spółka z ograniczoną odpowiedzialnością z siedzibą w Łodzi przy ulicy Niciarnianej 51/53, 92-320',
        'Maxus': 'Krotoski ElectroMobility Sp. z o.o. z siedzibą w Łodzi (92-320), ul. Niciarniana 51/53',
      }
    };
  },
};
</script>
<style lang="scss">
    .c-footer{
        max-width: 1630px;
        padding: 2rem .5rem;
        margin: 0 auto;
    }
</style>
